import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=7f1d1c7e&scoped=true&"
import script from "./Version.vue?vue&type=script&lang=js&"
export * from "./Version.vue?vue&type=script&lang=js&"
import style0 from "./Version.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Version.vue?vue&type=style&index=1&id=7f1d1c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d1c7e",
  null
  
)

export default component.exports